import { useContext, useState } from 'react';
import { AppContext } from '../../contexts/app/context';
import { ContactsListWrapper } from '../../styles/contacts';
import DraftAttendeeRow from './DraftAttendeeRow';
import DissociateGuestModal from './modals/DissociateGuestModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DraftAttendeesList({
  draftAttendees,
  openPreviewModal,
  openAssociationModal,
  getAssociations
}) {
  const {
    appName
  } = useContext(AppContext);
  const [contactToDissociate, setContactToDissociate] = useState(null);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ContactsListWrapper, {
      children: draftAttendees.map(attendee => /*#__PURE__*/_jsx(DraftAttendeeRow, {
        attendee: attendee,
        setContactToDissociate: setContactToDissociate,
        openPreviewModal: openPreviewModal,
        getAssociations: getAssociations,
        openAssociationModal: openAssociationModal
      }, attendee.email))
    }), contactToDissociate ? /*#__PURE__*/_jsx(DissociateGuestModal, {
      setContactToDissociate: setContactToDissociate,
      contactToDissociate: contactToDissociate,
      appName: appName,
      getAssociations: getAssociations
    }) : null]
  });
}
export default DraftAttendeesList;